export const MAIN_STORE_VERSION = 1
export const SECURE_STORE_VERSION = 1

export const mainStoreMigrations = {}

export const secureStoreMigrations = {}
